import React from "react";
import "../../styles/whyWe.css";
import img from "../../images/location.png";

const Locations = () => {
  const offices = [
    {
      country: "Россия",
      city: "Москва",
      address: "БЦ «Ситидел», ул. Садовая-Самотёчная, д. 16, стр. 1",
    },
    {
      country: "Европа",
      city: "Берлин, Германия",
      address: "Friedrichstraße 88, 10117 Berlin, Germany",
    },
    {
      country: "Казахстан",
      city: "Алматы",
      address: "БЦ «Нурлы Тау», проспект Аль-Фараби 19, блок 2Б",
    },
  ];

  return (
    <section className="locations common__section" id="whywe">
      <div className="innerSection container">
        <img src={img} />
        
        <div className="textBlock">
          <h2>Наши офисы</h2>
          <div className="officesList">
            {offices.map((office, index) => (
              <div key={index} className="officeItem">
                <h4>{office.country}</h4>
                <p><strong>{office.city}</strong></p>
                <p>{office.address}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;
